import { render, staticRenderFns } from "./name.vue?vue&type=template&id=c88ac8d2&scoped=true&"
import script from "./name.vue?vue&type=script&lang=js&"
export * from "./name.vue?vue&type=script&lang=js&"
import style0 from "./name.vue?vue&type=style&index=0&id=c88ac8d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88ac8d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c88ac8d2')) {
      api.createRecord('c88ac8d2', component.options)
    } else {
      api.reload('c88ac8d2', component.options)
    }
    module.hot.accept("./name.vue?vue&type=template&id=c88ac8d2&scoped=true&", function () {
      api.rerender('c88ac8d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/validation/name.vue"
export default component.exports